import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
} from 'typeorm';
import { BaseEntity } from './base.entity';
import { MoverGroupEntity } from './mover-group.entity';
import { MoverRbacRoleEntity } from './mover-rbac-role.entity';
import { MoverWorkdComponentEntity } from './mover-workd-component.entity';

@Index('_fk__mover_group__id', ['fkMoverGroupId'], {})
@Index('_fk__mover_workd_component__id', ['fkMoverWorkdComponentId'], {})
@Entity('_mover')
export class MoverEntity extends BaseEntity {
	@Column('int', {
		name: '_fk__mover_group__id',
		nullable: true,
		unsigned: true,
	})
	public fkMoverGroupId!: number | null;

	@Column('int', { name: '_fk__mover_workd_component__id', unsigned: true })
	public fkMoverWorkdComponentId!: number;

	@Column('longtext', { name: '_workdComponentInput' })
	public workdComponentInput!: string;

	@Column('varchar', { name: '_label', length: 64 })
	public label!: string;

	@Column('varchar', { name: '_key', length: 64 })
	public key!: string;

	@Column('varchar', { name: '_icon', length: 64 })
	public icon!: string;

	@Column('longtext', { name: '_countQuery' })
	public countQuery!: string;

	@Column('varchar', {
		name: '_pathToResult',
		length: 255,
		default: () => "'meta.totalRecords'",
	})
	public pathToResult!: string;

	@Column('text', { name: '_description', nullable: true })
	public description!: string | null;

	@Column('longtext', { name: '_stateRanges', nullable: true })
	public stateRanges!: string | null;

	@Column('varchar', { name: '_feature', nullable: true, length: 64 })
	public feature!: string | null;

	@Column('varchar', {
		name: '_pathToMediumAlert',
		nullable: true,
		length: 255,
	})
	public pathToMediumAlert!: string | null;

	@Column('varchar', { name: '_pathToHighAlert', nullable: true, length: 255 })
	public pathToHighAlert!: string | null;

	@ManyToOne(() => MoverGroupEntity, (moverGroup) => moverGroup.movers, {
		onDelete: 'NO ACTION',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: '_fk__mover_group__id', referencedColumnName: 'id' }])
	public fkMoverGroup!: MoverGroupEntity;

	@ManyToOne(
		() => MoverWorkdComponentEntity,
		(moverWorkdComponent) => moverWorkdComponent.movers,
		{ onDelete: 'NO ACTION', onUpdate: 'NO ACTION' },
	)
	@JoinColumn([
		{ name: '_fk__mover_workd_component__id', referencedColumnName: 'id' },
	])
	public fkMoverWorkdComponent!: MoverWorkdComponentEntity;

	@OneToMany(
		() => MoverRbacRoleEntity,
		(moverRbacRole) => moverRbacRole.fkMover,
		{},
	)
	public moverRbacRoles!: Array<MoverRbacRoleEntity>;
}
